<template>
  <div
    class="audience-cta-wrapper audience-cta-wrapper-requesr"
    :class="{'d-none': enableAudienceAdmissionForm}"
  >
    <div class="audience-cta">
      <div class="text-center audience-request">
        <div class="audience-cta__description title-request">
          😍 {{ $t('Enjoy this presentation?') }}
        </div>
        <div class="d-flex">
          <RequestPresentationBtn class="button" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import RequestPresentationBtn from '@/components/footer/RequestPresentationBtn.vue'

export default {
  components: {
    RequestPresentationBtn,
  },
  props: {
    footerBannerURL: {
      type: String,
      default: '',
    },
    handleAudienceCtaClick: {
      type: Function,
      default: () => {},
    },
    enableAudienceAdmissionForm: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      slide: (state) => state.slide,
    }),
  },
  mounted() {
    document.body.classList.add('has-footer-cta')
  },
  destroyed() {
    document.body.classList.remove('has-footer-cta')
  },
}
</script>

<style lang="scss" scoped>
.fa-angle-right {
  position: relative;
  top: 1px;
}
.audience-cta-wrapper {
  -webkit-user-select: none; /* Chrome all / Safari all */
  -moz-user-select: none; /* Firefox all */
  -ms-user-select: none; /* IE 10+ */
  user-select: none; /* Likely future */
  text-decoration: none;
}

.audience-cta {
  display: flex;
  background: #ffffff;
  padding: 12px;
  width: 100%;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.08);

  .title-request {
    font-weight: bold;
  }

  .audience-request {
    display: block;
    max-width: 678px;
    width: 100%;

    .button {
      min-width: 160px;
      padding-left: 4px;
      padding-right: 4px;
      text-align: center;
      border-radius: 30px;
      margin: 0 4px;
      max-width: 200px;
      width: 100%;
      font-size: 14px;
      font-weight: bold;
      &:hover {
        background-color: #257ADC;
      }
      @media (max-width: 300px) {
        min-width: 120px;
        font-size: 12px;
      }
      &.link-cta {
        background-color: #fff;
        color: #333;
        text-decoration: none;
        border: 1px solid #ddd;
        &:hover {
          color: #000;
        }
      }
    }

    .d-flex {
      justify-content: center;
    }

  }

  &:hover,
  &:focus,
  &:active {
    .audience-cta__link {
      color: #257adc;
    }

    .audience-cta__hero-image-fireworks {
      opacity: 1;
    }
  }
}

.audience-cta__description {
  color: #4b4b4b;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  margin: 0 0 8px;
}

.audience-cta__link {
  font-size: 14px;
  line-height: 14px;
  color: #348ef6;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  text-decoration: none;
}

.audience-cta__hero-image-wrapper {
  position: relative;

  .audience-cta__hero-image {
    margin: 0 8px 0 0;
    display: inline-block;
    height: 65px;
    width: 65px;
  }

  .audience-cta__hero-image-fireworks {
    opacity: 0;
    position: absolute;
    top: -21px;
    left: -7px;
    width: 75px;
    height: 75px;
  }
}
</style>
